import { Typography } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'

export const TotalPercentCell = ({ total_percent, className = '' }) => (
  <Typography
    className={className}
    component={'span'}
    variant={'Body-15'}
    color={'Label-Fifth'}
  >
    {total_percent}
  </Typography>
)

TotalPercentCell.propTypes = {
  total_percent: PropTypes.number,
  className: PropTypes.string,
}
